/*!
 * Built by Revolist
 */
import { O as OverlaySelection, d as defineCustomElement$1 } from './revogr-overlay-selection2.js';

const RevogrOverlaySelection = OverlaySelection;
const defineCustomElement = defineCustomElement$1;

export { RevogrOverlaySelection, defineCustomElement };
